import productsTree from './products-tree';

export default function initRequests(apiUrl) {
  return {
    productsTree: productsTree(apiUrl),
  };
}
